<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}

const { sale } = defineProps<Props>();

// COMPOSABLES
const { isBundle, isBundleMulti } = useSaleType(() => sale.type);
const { title: saleTitle } = useSaleTitle(() => sale);
const { getPlatformBusClassesLabel } = usePlatformBusClass();
</script>

<template>
    <div class="p-4">
        <p class="text-lg font-medium">{{ saleTitle }}</p>

        <div class="text-toned">
            <p v-if="!isBundleMulti && sale.mainAsset.class">{{ getPlatformBusClassesLabel(sale.mainAsset.class) }}</p>
            <p v-if="!isBundle">VIN: {{ sale.mainAsset.vin }}</p>
        </div>
    </div>
</template>
